<template>
  <v-dialog v-model="show" scrollable max-width="1180">
    <v-card v-if="detail">
      <v-card-title class="primary white--text py-3">
        <div class="font-weight-bold">Detail</div>
        <v-spacer />
        <v-btn icon dark @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pa-5 grey lighten-4 detail-content">
        <v-card class="mb-4 profile-card" outlined>
          <v-card-text class="pa-5">
            <div class="title font-weight-bold mb-5 black--text">Riwayat Presensi</div>
            <v-row align="center">
              <v-col cols="12" md="2" class="text-center text-md-left">
                <v-card width="140" height="112" color="deep-purple lighten-1" class="mx-auto mx-md-0 rounded-lg" flat>
                  <v-card-text class="fill-height d-flex align-center justify-center pa-0">
                    <v-avatar :size="74" color="grey lighten-4">
                      <v-img :src="avatarPlaceholder(detail)" alt="avatar" />
                    </v-avatar>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" md="10">
                <div class="headline font-weight-bold black--text">{{ pVal(detail, 'nama') }}</div>
                <div class="body-2 text--secondary mb-3">
                  Pengguna <span class="mx-2">|</span> {{ instansiName(detail) }}
                </div>
                <v-divider class="mb-4" />
                <v-row>
                  <v-col v-for="summary in summaries" :key="summary.title" cols="12" sm="6" md="4">
                    <v-card outlined flat class="summary-card">
                      <v-card-text class="pa-3">
                        <div class="caption font-weight-bold text-uppercase text--disabled mb-1">{{
                          summary.title
                        }}</div>
                        <div class="subtitle-1 font-weight-bold" :class="summary.valueClass">{{ summary.value }}</div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <div class="history-title d-flex align-center mb-3">
          <v-icon x-small class="mr-2" color="blue-grey lighten-1">mdi-clock-outline</v-icon>
          <span class="caption font-weight-bold text-uppercase blue-grey--text text--darken-2">
            Riwayat Presensi Yang Terindikasi
          </span>
        </div>

        <v-card class="history-period-card mb-3" outlined>
          <v-card-text class="py-3 px-4">
            <div class="history-filter-wrap">
              <div class="d-flex align-start history-period-info">
                <v-icon color="primary" small class="mr-3 mt-1">mdi-calendar-clock</v-icon>
                <div>
                  <div class="body-2 blue-grey--text text--darken-3">
                    Periode: <span class="font-weight-bold black--text">{{ periodeText }}</span>
                  </div>
                  <div class="caption text--disabled mt-1">
                    {{ filteredRiwayat.length }} dari {{ riwayat.length }} riwayat ditampilkan.
                  </div>
                </div>
              </div>
              <div class="history-filter-actions">
                <v-menu
                  ref="dateRangeMenu"
                  v-model="dateRangeMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="dateRangeText"
                      label="Rentang Tanggal"
                      prepend-icon="mdi-calendar"
                      readonly
                      clearable
                      dense
                      outlined
                      hide-details
                      class="history-date-filter"
                      v-on="on"
                      @click:clear="resetDateFilter"
                    />
                  </template>
                  <v-date-picker v-model="internalDates" no-title scrollable locale="id" range color="primary">
                    <v-spacer />
                    <v-btn depressed text color="primary" @click="dateRangeMenu = false">Cancel</v-btn>
                    <v-btn depressed text color="primary" @click="$refs.dateRangeMenu.save(internalDates)">OK</v-btn>
                  </v-date-picker>
                </v-menu>
                <v-btn
                  small
                  outlined
                  rounded
                  color="primary"
                  class="text-none font-weight-bold reset-history-filter"
                  :disabled="!hasDateFilter"
                  @click="resetDateFilter"
                >
                  Reset
                </v-btn>
              </div>
            </div>
          </v-card-text>
        </v-card>

        <m-card-list
          class="history-list"
          :items="filteredRiwayat"
          :headers="headers"
          :page="null"
          no-data="Riwayat tidak tersedia"
        >
          <template v-slot:items="{ item }">
            <tr v-if="$vuetify.breakpoint.smAndUp">
              <td class="py-3 px-4 text-no-wrap">
                <div>{{ item.waktu_scan.slice(0, 11) | toSDN }}</div>
                <div class="text-caption text--secondary">{{ $setTimezone(item.waktu_scan, 2) }}</div>
              </td>
              <td class="py-3 px-4 font-weight-medium text--secondary">{{ deviceName(item) }}</td>
              <td class="py-3 px-4">
                <div v-if="item.latitude && item.longitude" class="location-cell">
                  <div v-if="item.nama_lokasi" class="caption text--secondary mb-1">{{ item.nama_lokasi }}</div>
                  <v-btn
                    x-small
                    depressed
                    rounded
                    class="text-none px-2 maps-action location-chip"
                    @click="toMaps(item.latitude, item.longitude)"
                  >
                    <v-icon x-small left>mdi-map-marker-outline</v-icon>
                    {{ item.latitude }}, {{ item.longitude }}
                  </v-btn>
                </div>
                <span v-else class="text-caption text--secondary">-</span>
              </td>
              <td class="py-3 px-4">
                <v-chip v-if="item.version_code" x-small class="font-weight-bold version-chip">
                  <v-icon x-small left>mdi-cellphone</v-icon>
                  Masook {{ pVal(item, 'version_code') }}
                </v-chip>
              </td>
              <td class="py-3 px-4">
                <template v-if="indicationTypes(item).length">
                  <v-chip
                    v-for="indikasi in indicationTypes(item)"
                    :key="indikasi"
                    x-small
                    class="font-weight-bold mr-1 mb-1 indication-chip"
                    :class="indikasi === 'lokasi' ? 'location-indication-chip' : 'version-indication-chip'"
                  >
                    <v-icon x-small left>{{
                      indikasi === 'lokasi' ? 'mdi-map-marker-outline' : 'mdi-cellphone'
                    }}</v-icon>
                    {{ INDIKASI_LABELS[indikasi] }}
                  </v-chip>
                </template>
                <span v-else class="text-caption text--secondary"></span>
              </td>
            </tr>
            <tr v-else>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mr-2">{{ headers[0].text }}</div>
                <div class="v-data-table__mobile-row__cell">
                  <div>{{ item.waktu_scan.slice(0, 11) | toSDN }}</div>
                  <div class="text-caption text--secondary">{{ $setTimezone(item.waktu_scan, 2) }}</div>
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mr-2">{{ headers[1].text }}</div>
                <div class="v-data-table__mobile-row__cell">{{ deviceName(item) }}</div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mr-2">{{ headers[2].text }}</div>
                <div class="v-data-table__mobile-row__cell">
                  <div v-if="item.latitude && item.longitude" class="location-cell text-right">
                    <div v-if="item.nama_lokasi" class="caption text--secondary mb-1">{{ item.nama_lokasi }}</div>
                    <v-btn
                      x-small
                      depressed
                      rounded
                      class="text-none px-2 maps-action location-chip"
                      @click="toMaps(item.latitude, item.longitude)"
                    >
                      <v-icon x-small left>mdi-map-marker-outline</v-icon>
                      {{ item.latitude }}, {{ item.longitude }}
                    </v-btn>
                  </div>
                  <span v-else class="text-caption text--secondary">-</span>
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mr-2">{{ headers[3].text }}</div>
                <div class="v-data-table__mobile-row__cell">{{
                  item.version_code ? `Masook ${item.version_code}` : '-'
                }}</div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mr-2">{{ headers[4].text }}</div>
                <div class="v-data-table__mobile-row__cell">
                  <template v-if="indicationTypes(item).length">
                    <v-chip
                      v-for="indikasi in indicationTypes(item)"
                      :key="indikasi"
                      x-small
                      class="font-weight-bold mr-1 mb-1 indication-chip"
                      :class="indikasi === 'lokasi' ? 'location-indication-chip' : 'version-indication-chip'"
                    >
                      {{ INDIKASI_LABELS[indikasi] }}
                    </v-chip>
                  </template>
                  <span v-else class="text-caption text--secondary"></span>
                </div>
              </td>
            </tr>
          </template>
        </m-card-list>

        <div class="caption text--disabled mt-3">
          <v-icon x-small color="grey lighten-1">mdi-information-outline</v-icon>
          Tombol lokasi menampilkan koordinat latitude dan longitude agar petugas dapat meninjau titik scan secara lebih
          kontekstual.
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { INDIKASI_COLORS, INDIKASI_LABELS } from '@/modules/profilKecuranganPengguna/const'

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    detail: {
      type: Object,
      default: null,
    },
    dates: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      INDIKASI_COLORS,
      INDIKASI_LABELS,
      internalDates: [],
      dateRangeMenu: false,
      headers: [
        { text: 'Waktu Scan', align: 'left', value: 'waktu_scan', width: '15%' },
        { text: 'Perangkat', align: 'left', value: 'perangkat', width: '15%' },
        { text: 'Lokasi', align: 'left', value: 'lokasi', width: '26%' },
        { text: 'Versi Aplikasi Masook', align: 'left', value: 'version_code', width: '22%' },
        { text: 'Jenis Indikasi', align: 'left', value: 'jenis_indikasi', width: '22%' },
      ],
    }
  },
  watch: {
    value(value) {
      if (value) this.applyInitialDates()
    },
    detail() {
      this.applyInitialDates()
    },
    dates() {
      this.applyInitialDates()
    },
  },
  computed: {
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    riwayat() {
      return (this.detail && this.detail.presensi_data) || []
    },
    normalizedDateRange() {
      return [...this.internalDates].sort()
    },
    filterStartDate() {
      return this.normalizedDateRange[0] || null
    },
    filterEndDate() {
      return this.normalizedDateRange[1] || this.filterStartDate
    },
    dateRangeText() {
      if (this.normalizedDateRange.length === 1) return this.formatDate(this.filterStartDate)
      return this.normalizedDateRange.map((date) => this.formatDate(date)).join(' — ')
    },
    filteredRiwayat() {
      return this.riwayat.filter((item) => {
        const scanDate = this.scanDateValue(item && item.waktu_scan)
        if (!scanDate) return false
        if (this.filterStartDate && scanDate < this.filterStartDate) return false
        if (this.filterEndDate && scanDate > this.filterEndDate) return false
        return true
      })
    },
    hasDateFilter() {
      return Boolean(this.internalDates.length)
    },
    totalTerindikasi() {
      return this.filteredRiwayat.filter((item) => this.indicationTypes(item).length).length
    },
    summaries() {
      return [
        {
          title: 'Total Scan',
          value: `${this.filteredRiwayat.length}x`,
          valueClass: 'black--text',
        },
        {
          title: 'Pertama Terdeteksi',
          value: this.formatDate(this.firstScan),
          valueClass: 'black--text',
        },
        {
          title: 'Terakhir Terdeteksi',
          value: this.formatDate(this.lastScan),
          valueClass: 'black--text',
        },
      ]
    },
    firstScan() {
      return this.filteredRiwayat.length ? this.filteredRiwayat[0].waktu_scan : null
    },
    lastScan() {
      return this.filteredRiwayat.length ? this.filteredRiwayat[this.filteredRiwayat.length - 1].waktu_scan : null
    },
    periodeText() {
      if (this.hasDateFilter) {
        return `${this.formatDate(this.filterStartDate || this.firstScan)} — ${this.formatDate(
          this.filterEndDate || this.lastScan
        )}`
      }
      if (!this.filteredRiwayat.length) return '-'
      return `${this.formatDate(this.firstScan)} — ${this.formatDate(this.lastScan)}`
    },
  },
  methods: {
    close() {
      this.show = false
    },
    applyInitialDates() {
      this.internalDates = [...this.dates]
      this.dateRangeMenu = false
    },
    resetDateFilter() {
      this.internalDates = []
      this.dateRangeMenu = false
    },
    scanDateValue(date) {
      if (!date || typeof date !== 'string') return null
      return date.slice(0, 10)
    },
    avatarPlaceholder(item) {
      return item && item.gender === 'P' ? 'img/cewek.png' : 'img/cowok.png'
    },
    instansiName(item) {
      return (
        (item && item.organisasi && item.organisasi.nama) ||
        this.pVal(item, 'instansi') ||
        this.pVal(item, 'organisasi_nama') ||
        '-'
      )
    },
    deviceName(item) {
      if (!item || !item.nama_perangkat) return '-'
      if (typeof item.nama_perangkat !== 'string') return item.nama_perangkat

      try {
        const data = JSON.parse(item.nama_perangkat)
        return data.nama || item.nama_perangkat
      } catch (e) {
        return item.nama_perangkat
      }
    },
    indicationTypes(item) {
      const result = []

      if (this.hasFraudScore(item && item.lokasi_score)) result.push('lokasi')
      if (this.hasFraudScore(item && item.version_score)) result.push('versi')

      return result
    },
    hasFraudScore(score) {
      return score !== null && score !== undefined && Number(score) !== 0
    },
    formatDate(date) {
      if (!date) return '-'
      return this.$options.filters.toSDN(date)
    },
    toMaps(lat, long) {
      const url = 'http://www.google.com/maps/place/' + lat + ',' + long
      window.open(url, '_blank')
    },
  },
}
</script>

<style scoped>
.detail-content {
  max-height: 82vh;
}

.profile-card,
.history-period-card {
  border-color: #dfe5ec !important;
  border-radius: 10px !important;
}

.history-title::after {
  content: '';
  display: block;
  height: 1px;
  background: #e4e9f0;
  flex: 1;
  margin-left: 10px;
}

.summary-card {
  background-color: #fafafa;
  border-color: #eef1f4 !important;
  border-radius: 8px !important;
}

.history-filter-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.history-period-info {
  min-width: 250px;
}

.history-filter-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  flex-wrap: wrap;
}

.history-date-filter {
  width: 260px;
}

.history-date-filter ::v-deep .v-input__prepend-outer {
  margin-right: 6px;
}

.history-date-filter ::v-deep .v-input__slot {
  min-height: 38px !important;
}

.history-date-filter ::v-deep input {
  font-size: 13px;
}

.reset-history-filter {
  height: 32px !important;
}

@media (max-width: 960px) {
  .history-filter-wrap {
    align-items: flex-start;
    flex-direction: column;
  }

  .history-filter-actions {
    justify-content: flex-start;
    width: 100%;
  }
}

.history-list ::v-deep .mt-5 {
  margin-top: 0 !important;
}

.history-list ::v-deep .v-data-table {
  border: 1px solid #eef1f4;
  border-radius: 10px;
  overflow: hidden;
}

.maps-action {
  min-height: 22px !important;
  height: auto !important;
  font-size: 11px;
  letter-spacing: 0;
}

.location-coordinate {
  line-height: 1.2;
  word-break: break-word;
}

.location-chip {
  background-color: #eaf4ff !important;
  border: 1px solid #add4ff !important;
  color: #2979ff !important;
}

.version-chip,
.version-indication-chip {
  background-color: #f5ecff !important;
  border: 1px solid #dec8ff !important;
  color: #7c3aed !important;
}

.location-indication-chip {
  background-color: #eaf4ff !important;
  border: 1px solid #add4ff !important;
  color: #2979ff !important;
}

.indication-chip {
  height: 22px !important;
}
</style>
